import {
    Box,
    Button,
    Divider,
    FormControl,
    IconButton,
    InputLabel,
    MenuItem,
    Modal,
    Select,
    TextField,
    Typography,
    useMediaQuery
} from '@mui/material'
import { CarnivoreModalProps } from '../../_types/modal-props.interface'
import useBoolean from '../../hooks/useBoolean'
import { StyleHelper } from '../style-helper'
import { Cancel } from '@mui/icons-material'
import { FormEvent, useState } from 'react'
import { useTextInput } from '../../hooks/useTextField'
import LoadingButton from '../controls/loading-btn'
import { useError } from '../../context/error'
import { CommentService } from '../../services/comment.service'
import { useSuccess } from '../../context/success'
import SectorPerformanceTable from '../SectorPerformanceTable'

const SectorPerformanceModal: React.FC<CarnivoreModalProps> = ({
    open,
    onClose,
    size = 'lg'
}) => {
    const isSmallScreen = useMediaQuery('(max-width:600px)')



    const _getWidth = () => {
        if (isSmallScreen) {
            return '90%'
        }
        switch (size) {
            case 'sm':
                return '30%'
            case 'md':
                return '60%'
            case 'lg':
                return '80%'
        }
    }


    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby='modal-modal-title'
            aria-describedby='modal-modal-description'
        >
            <Box
                sx={{
                    position: 'fixed',
                    top: '50svh',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: _getWidth(),
                    maxWidth: '100%',
                    maxHeight: '90dvh', // prevent overflow on mobile
                    overflowY: 'scroll',
                    bgcolor: `background.paper`,
                    border: `2px solid #000`,
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                }}
            >
                <Box display={'flex'} justifyContent={'flex-end'} alignItems={'center'}>
                    {/* <Typography variant='subtitle1' fontWeight={'bold'}>
                    Cancellation Request
                  </Typography> */}
                    <IconButton onClick={onClose}>
                        <Cancel />
                    </IconButton>
                </Box>

                <SectorPerformanceTable />
            </Box>
        </Modal>
    )
}

export default SectorPerformanceModal
